__webpack_require__.p = "https://inforportal-dev.synergy.net.au/";